import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';

import { Button } from '@spacefill/uikit/src/components/Button';
import { NotFound } from '@spacefill/uikit/src/components/NotFound';
import { safeLocalStorage } from '@spacefill/uikit/src/utils/storage';

export function getLocalStorageData() {
    const localStorageData = {};
    for (let i = 0; i < safeLocalStorage.length; i++) {
        const key = safeLocalStorage.key(i);
        localStorageData[key] = safeLocalStorage.getItem(key);
    }
    return localStorageData;
}

const CHUNK_LOAD_ERROR_PATTERN = /dynamically imported module|Importing a module script failed/i;

export const ErrorComponent = () => {
    const error = useRouteError();
    const { t } = useTranslation();
    const isChunkLoadError = CHUNK_LOAD_ERROR_PATTERN.test(error?.message ?? '');

    return (
        <div className='h-full overflow-auto'>
            <NotFound
                errorCode=''
                errorMessage={
                    isChunkLoadError
                        ? t('A new version of the application is available. Please reload the page.')
                        : t('An error occurred')
                }
                details={
                    <pre className='p-4 my-2 font-["Courier"] leading-5 bg-violet-100 rounded-md whitespace-pre-wrap'>
                        {error.message + '\n' + error.stack}
                    </pre>
                }
                cta={
                    <div className='flex gap-2'>
                        <Button onClick={() => window.location.reload()}>
                            {isChunkLoadError ? t('Reload') : t('Retry')}
                        </Button>
                        <Button
                            type='link'
                            to='/'
                            variant='outlined'
                        >
                            {t('Return to the home page')}
                        </Button>
                    </div>
                }
            />
        </div>
    );
};
